"use client";

import { Img } from "@/components/image";

export const HeroLandingImage = ({
  desktopImageUrl,
  mobileImageUrl,
}: {
  desktopImageUrl: string;
  mobileImageUrl: string;
}) => {
  return (
    <>
      <div className="order-1 w-[300px] rounded-2xl bg-brand-grey1 p-2 md:order-0 md:mt-6 md:w-[650px] lg:mt-0">
        {/* Desktop */}
        <Img
          alt="Multidiet hero"
          className="h-full w-full object-cover max-md:hidden"
          height={430}
          src={desktopImageUrl}
          width={650}
        />
        {/* Mobile */}
        <Img
          alt="Multidiet hero"
          className="h-full w-full object-cover md:hidden"
          height={400}
          src={mobileImageUrl}
          width={250}
        />
      </div>
    </>
  );
};
